export default __webpack_public_path__ + "static/media/thsarabunnew_italic-webfont.4881429c.woff";